<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane key="quotationMaterial" label="原材料报价" name="quotationMaterial">
                <quotationMaterial-tab ref="quotationMaterial"></quotationMaterial-tab>
            </el-tab-pane>
            <el-tab-pane key="quotationProcessCost" label="加工费" name="quotationProcessCost">
                <quotationProcessCost-tab ref="quotationProcessCost"></quotationProcessCost-tab>
            </el-tab-pane>
            <el-tab-pane key="quotationConversion" label="加工费换算" name="quotationConversion">
                <quotationConversion-tab ref="quotationConversion"></quotationConversion-tab>
            </el-tab-pane>
            <el-tab-pane key="quotationToolsCost" label="模具夹具检具成本" name="quotationToolsCost">
                <quotationToolsCost-tab ref="quotationToolsCost"></quotationToolsCost-tab>
            </el-tab-pane>
            <el-tab-pane key="quotationOutBuy" label="外购零部件费" name="quotationOutBuy">
                <quotationOutBuy-tab ref="quotationOutBuy"></quotationOutBuy-tab>
            </el-tab-pane>
            <el-tab-pane key="quotationBox" label="包装运输费" name="quotationBox">
                <quotationBox-tab ref="quotationBox"></quotationBox-tab>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
import quotationMaterialTab from './quotationMaterial-tab'
import quotationProcessCostTab from './quotationProcessCost-tab'
import quotationConversionTab from './quotationConversion-tab'
import quotationToolsCostTab from './quotationToolsCost-tab'
import quotationOutBuyTab from './quotationOutBuy-tab'
import quotationBoxTab from './quotationBox-tab'
import moment from 'moment'
// require('@/mock/mockContract');
export default {
    data() {
        return {
            activeName:''
        }
    },
    components: {
        quotationMaterialTab,
        quotationProcessCostTab,
        quotationConversionTab,
        quotationToolsCostTab,
        quotationOutBuyTab,
        quotationBoxTab,
    },
    mounted(){
        this.activeName = 'quotationMaterial'
        this.$refs[this.activeName].getDataList()
    },
    methods: {
        handleClick(tab) {
            this.$refs[this.activeName].getDataList()
        }
    }
}
</script>

<style lang="scss" scoped>
.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
